import { render } from "./QuizAnswerTab.vue?vue&type=template&id=5b384d23"
import script from "./QuizAnswerTab.vue?vue&type=script&lang=js"
export * from "./QuizAnswerTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__